// Full-screen gate shown after login when the user must set their own password
// (temp password issued by an admin). Blocks the app until changed.
import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ChangePasswordForm from "./ChangePasswordForm";

export default function ForcePasswordChange() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen w-full grid place-items-center bg-[#F5F3F0] p-6" data-testid="force-password-change">
            <div className="w-full max-w-[440px] bg-white border rounded-[16px] shadow-brand p-7" style={{ borderColor: "#E5E0DA" }}>
                <div className="flex items-center gap-2 mb-1.5">
                    <ShieldCheck className="w-5 h-5" style={{ color: "#C75A1B" }} />
                    <span className="text-[11px] uppercase tracking-[.2em] font-bold" style={{ color: "#9A968F" }}>Secure your account</span>
                </div>
                <h1 className="font-display text-2xl font-bold text-[#1F1F1F]">Set your password</h1>
                <p className="text-[13px] mt-2 mb-5" style={{ color: "#6F6A64" }}>
                    Welcome, {user?.name?.split(" ")[0] || "there"}. For security, please replace your temporary password before continuing.
                </p>
                <ChangePasswordForm currentLabel="Temporary password" onDone={() => { /* refreshUser in context clears the gate */ }} />
                <button onClick={logout} data-testid="force-logout"
                    className="mt-4 w-full text-[12px] font-semibold inline-flex items-center justify-center gap-1.5 py-2 rounded-[10px] border hover:bg-[#F6F4F0]" style={{ borderColor: "#E5E0DA", color: "#6F6A64" }}>
                    <LogOut className="w-3.5 h-3.5" /> Sign out instead
                </button>
            </div>
        </div>
    );
}
